import src from "IMAGE";
export default { src, width: 206, height: 165, blurWidth: 0, blurHeight: 0};
